export function createFallbackName(id: string): string {
    return `#${id}`;
}
